export enum IOrganizationAnalyticsEventEnum {
  Id = 'OrgAnalyticsEvent.id',
  AccountId = 'OrgAnalyticsEvent.accountid',
  UserId = 'OrgAnalyticsEvent.userid',
  Count = 'OrgAnalyticsEvent.count',
  TotalDuration = 'OrgAnalyticsEvent.totalDuration',
  MaxDuration = 'OrgAnalyticsEvent.maxDuration',
  UserCount = 'OrgAnalyticsEvent.userCount',
  Duration = 'OrgAnalyticsEvent.duration',
  CreatedAt = 'OrgAnalyticsEvent.createdat',
  UpdatedAt = 'OrgAnalyticsEvent.updatedat',
  CreatedBy = 'OrgAnalyticsEvent.createdby',
  UpdatedBy = 'OrgAnalyticsEvent.updatedby',
  DeletedAt = 'OrgAnalyticsEvent.deletedat',
  DeletedBy = 'OrgAnalyticsEvent.deletedby',
  TeamId = 'OrgAnalyticsEvent.teamid',
  EventType = 'OrgAnalyticsEvent.eventtype',
  AppId = 'OrgAnalyticsEvent.appid',
  SubscriptionId = 'OrgAnalyticsEvent.subscriptionid',
  StartTime = 'OrgAnalyticsEvent.starttime',
  LocalStartTime = 'OrgAnalyticsEvent.localstarttime',
  EndTime = 'OrgAnalyticsEvent.endtime',
  ExternalId = 'OrgAnalyticsEvent.externalid',
  Title = 'OrgAnalyticsEvent.title',
  Recurring = 'OrgAnalyticsEvent.recurring',
  AttendeeCount = 'OrgAnalyticsEvent.attendeecount',
  LocalStartDate = 'OrgAnalyticsEvent.localstartdate',
  DayCount = 'OrgAnalyticsEvent.dayCount',
  WeekCount = 'OrgAnalyticsEvent.weekCount',
  WeekdayIndex = 'OrgAnalyticsEvent.weekdayindex',
  DepartmentId = 'OrgAnalyticsEvent.departmentid',
}

export enum IOrganizationAnalyticsEventSegmentsEnum {
  monday = 'OrgAnalyticsEvent.monday',
  tuesday = 'OrgAnalyticsEvent.tuesday',
  wednesday = 'OrgAnalyticsEvent.wednesday',
  thursday = 'OrgAnalyticsEvent.thursday',
  friday = 'OrgAnalyticsEvent.friday',
  saturday = 'OrgAnalyticsEvent.saturday',
  sunday = 'OrgAnalyticsEvent.sunday',
}
